import styles from "./SyncNowModal.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useState } from "react";
import { Ok } from "react-ikonate";
import { Modal } from "shared/Modal";

/**
 *
 * Modal used for syncing members of groups in the manage tab of the groups page.
 */

export function SyncNowModal({ isOpen, onClose, onClick, withoutRefresh }) {
  const [checked, setChecked] = useState(withoutRefresh);
  if (!isOpen) {
    return "";
  }
  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="SYNC GROUP"
        closeBtn="none"
        className={styles.modal}
        onClose={onClose}
        children={
          <>
            <div className={styles.description}>
              Sync all members of [ Name of Group ].
            </div>

            <button
              className={classNames(
                styles.checkboxContainer,
                checked && styles.checked
              )}
              onClick={() => setChecked(!checked)}
            >
              <div
                className={classNames(styles.icon, !checked && styles.hidden)}
              >
                <Ok />
              </div>
            </button>
            <div className={styles.checkboxLabel}>
              Sync without refreshing LOS information
            </div>

            <div className={styles.buttonContainer}>
              <button
                className={classNames(styles.button, styles.cancelBtn)}
                onClick={onClose}
              >
                CANCEL
              </button>
              <button
                className={styles.button}
                onClick={() => onClick(checked)}
              >
                SYNC
              </button>
            </div>
          </>
        }
      />
    </div>
  );
}

SyncNowModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  withoutRefresh: PropTypes.bool,
};
